module.exports = __webpack_public_path__ + "static/img/reporticon3.510ef7b3.png";